export default __webpack_public_path__ + "static/media/cmpc.753fa8cb.png";